<template>
	<div class="login_page">
		<transition name="form-fade" mode="in-out">
			<div>
				<!-- <div class="top">
					<div class="logo"></div>
					<div style="margin-right:50px;float:right;cursor: pointer;" @click="register">账号注册</div>
					 <div style="margin-right:150px;float:right">使用条款</div>
				</div>  -->
				<div class="item">
					<section class="form_contianer loginForm">
						<div class="manage_tip">
							<span class="title">加阳华枫快运</span>
						</div>
						<el-form :model="loginForm" :rules="rules" ref="loginForm" size="medium">
							<el-form-item prop="userName" style="margin-top:60px;">
								<span class="fa-tips"><i class="fa fa-user"></i></span>
								<el-input class="area" type="text" placeholder="用户名" v-model.trim="loginForm.userName">
								</el-input>
							</el-form-item>
							<el-form-item prop="password" style="margin-top:40px;">
								<span class="fa-tips"><i class="fa fa-lock"></i></span>
								<el-input class="area" type="password" placeholder="密码" v-model.trim="loginForm.password">
								</el-input>
							</el-form-item>
							<el-form-item>
								<!-- <el-checkbox style="float:right" v-model="loginForm.checkedPwd">记住密码</el-checkbox> -->
							</el-form-item>
							<el-form-item style="margin-top:40px;">
								<el-button type="primary" @click="login('loginForm')" class="submit_btn">登录</el-button>
							</el-form-item>
							<div class="tiparea">
								<!-- <p class="wxtip">温馨提示：</p>
							<p class="tip">未登录过的新用户，自动注册</p>
							<p class="tip">注册过的用户可凭账号密码登录</p> -->
							</div>
							<div class="icp-info">
								<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
									上海华枫新达供应链有限公司 沪ICP备2025137398号-1
								</a>
							</div>
						</el-form>
					</section>
				</div>
			</div>
		</transition>
	</div>
</template>
	

<script>
	//import axios from 'utils/axios'
	import * as mUtils from 'utils/mUtils'
	 import * as login from '@/api/login'
	// import * as admin from 'utils/admin'
	import {
		mapActions,
		mapState,
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				//登录用户，密码和确认
				loginForm: {
					userName: '',
					password: '',
					checkedPwd: false,
				},
				// 用户权限
				RoleID:'',
				//输入规则
				rules: {
					userName: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
					],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
				},
				companyId: 0,
			}
		},
		computed: {
			...mapGetters(['menuitems', 'isLoadRoutes'])
		},
		created() {
			//this.generateMenuPushIndex();
			
		},
		methods: {
			...mapActions(['addMenu', 'loadRoutes']),
			//保存菜单栏到缓存
			saveUserInfo(data) {
				mUtils.setStore('userinfo', data)
				mUtils.setStore('roleID', data.roleId)
				this.RoleID=data.roleId
				// console.log(this.RoleID);
			},
			//模拟动态生成菜单并定位到index
			generateMenuPushIndex(data) {
				let that=this
				that.companyId=data.companyId
				const menuData = []
				mUtils.setStore('menuData', menuData) // 将菜单放入缓存。
				this.addMenu(menuData); // 生成菜单,将菜单放入store 。
				if (!this.isLoadRoutes) { // 首次进来为false,改变其状态为true
					const routes = mUtils.generateRoutesFromMenu(menuData) //根据菜单生成的路由信息,需要将数据库返回的对象key值转成小写
					// console.log(routes)
					const asyncRouterMap = [{
							path: '/404',
							name: '404',
							hidden: true,
							component: require('page/404.vue')
						},
						{
							path: '/index',
							name: '',
							hidden: true,
							component: require('layout/home.vue'),
							redirect: '/index',
							children: routes
						}
					]
					this.$router.addRoutes(asyncRouterMap);
					this.loadRoutes() // true,第二次进来不用再去加载路由
				}
				// console.log(this.adminId)
				    //  this.$router.push('/homePage')
				if (that.RoleID == 1) {
				
					that.$router.push('/orderList')
				} else if (that.RoleID == 2){
				
					that.$router.push('/distribution/order')
				}else if (that.RoleID == 3){
				
					that.$router.push('/delivery/order')
				}
			},
			login(loginForm) {
				let that = this
				this.$refs.loginForm.validate((valid) => {
					if (valid) {
						const loading = this.$loading({
							lock: true,
							text: '登录中',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						// that.$sub.post('/v1/login/webLogin', {
						// 		userName: that.loginForm.userName,
						// 		// password: that.loginForm.password,
						// 		 password: that.$md5(that.loginForm.password)
						// 	})
							let data={
								userName: that.loginForm.userName,
								// password: that.loginForm.password,
								 password: that.$md5(that.loginForm.password)
							}
							login.webLogin(data).then((res)=> {
						        
								loading.close();
							if(res.data.code==0){
								
									// if(mUtils.getStore('token')){
									// 	mUtils.removeStore('token')
									// 	mUtils.setStore('token',res.data.data.token)
									// }	else{
									// 	mUtils.setStore('token',res.data.data.token)
									// }
									
					         
	                                    //  that.$router.push('/homePage')
										let str = 'adminId:'+(res.data.data.adminId||'')	+',realName:'+res.data.data.roleName +',userName:'+res.data.data.userName
							
									
										that.$cookieStore.setCookie( 'zbt_',str)
										// that.companyId=res.data.data.admin.companyId
								
	                                    // //  that.$router.push('/homePage')
										// let str = 'adminId:'+(res.data.data.admin.adminId||'')+',roleId:'+(res.data.data.admin.roleId||'')+',token:'+(res.data.data.token||'')+',userName:'+res.data.data.admin.userName
										// +',roleName:'+res.data.data.admin.roleName +',mobile:'+res.data.data.admin.mobile+',tel:'+res.data.data.admin.tel
										// +',status:'+res.data.data.admin.status+',companyId:'+res.data.data.admin.companyId+',shopId:'+res.data.data.admin.shopId
									
										// that.$cookieStore.setCookie( 'zbt_',str)
										that.saveUserInfo(res.data.data);
										that.$store.dispatch('initLeftMenu'); //设置左边菜单始终为展开状态
										that.generateMenuPushIndex(res.data.data)
										 //模拟动态生成菜单并定位到index
									
								
								}
								if (res.data.code != 0) {

									that.$message({
										message: '请输入正确的用户名密码',
										type: 'warning'
									});
									return false;
								}
							})
					} else {
						return false;
					}
				});
			},
		}
	}
</script>
<style lang="less" scoped>
	.login_page {
		color: #fff;
		position: absolute;
		width: 100%;
		height: 100%;
		background: url(../assets/img/gx-bg.jpg) no-repeat center center;
		background-size: 100% 100%;
	}

	.top {
		margin-top: 50px;
        margin-left: 100px;

		div {
			position: relative;
        margin-top: -150px;
            float: left;
		}

		.logo {
			width: 128px;
			height: 128px;
			background: url(../assets/img/zhoubotong_logo.png) no-repeat center center;
			background-size: 100% 100%;
		}
	}
.item { 
		position: relative;
        margin-top: 0px;
    }

	.loginForm {
		background-color: #fff;
		padding: 20px;
		border-radius: 3px;
		box-shadow: 5px 5px 10px #01144c;

		.fa-tips {
			position: absolute;
			top: 0px;
			left: 10px;
			z-index: 20;
			color: #2a56a4;
			font-size: 18px;
		}

	}

	.manage_tip {
		margin-bottom: 20px;

		.title {
			font-weight: bold;
			font-size: 30px;
			color: #000;
		}

		.logo {
			width: 60px;
			height: 60px;
		}
	}

	.form_contianer {
		width: 320px;
		height: 350px;
		position: relative;
        padding-top: 300px;
        margin: 0px auto;
		padding: 50px;
		border-radius: 5px;
		text-align: center;

		.submit_btn {
			font-size: 16px;
			// letter-spacing:10px;
		}
	}

	.tiparea {
		text-align: left;
		font-size: 12px;
		color: #4cbb15;

		.tip {
			margin-left: 54px;
		}
	}

	.icp-info {
		text-align: center;
		margin-top: 30px;
		font-size: 12px;
		color: #999;

		a {
			color: #999;
			text-decoration: none;
			transition: color 0.3s ease;

			&:hover {
				color: #2a56a4;
				text-decoration: underline;
			}
		}
	}

	.form-fade-enter-active,
	.form-fade-leave-active {
		transition: all 1s;
	}

	.form-fade-enter,
	.form-fade-leave-active {
		transform: translate3d(0, -50px, 0);
		opacity: 0;
	}

	.loginForm {
		position: fixed;
		top:0;
		left:0;
		right:0;
		bottom: 0;
		margin:auto;
		.el-button--primary {
			background-color: #2a56a4;
			border: 1px solid #2a56a4;
		}
	}
</style>


// WEBPACK FOOTER //
// login.vue?60cbf749